import { ClaimListDetails } from "../../modules/claim/models/claimList.models";
import { ActionType } from "../action-type";
import { IClaimRes } from "../interface/homeInterface";

interface IinitialState {
    loading:boolean,
    error:any,
    ClaimList?:Array<ClaimListDetails>,
    timeStamp:any,
}

const initialState:IinitialState ={
    loading:false,
    error:null,
    ClaimList:null,
    timeStamp:null,
};

export const ClaimDetailsReducer = (initialState = {}, action) => {
    switch(action.type)
    {
        case "claim" :
            return action.payload;
        default :
         return initialState;
    }
}

export const UploadedMedicalIRDocs = (initialState = {}, action) => {
    switch(action.type)
    {
        case "medical":
            return action.payload;
        default:
            return initialState
    }
}

export const fetch_Claim_List_Reducer = (state:IinitialState = initialState, action:IClaimRes) => {
    switch (action.type) {
        case ActionType.FETCH_CLAIMLIST_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_CLAIMLIST_SUCCESS:
            return {
                ...state,
                loading:false,
                ClaimList:action.ClaimList,
                timeStamp:action.timeStamp,
                dataloaded:true
            }
        case ActionType.FETCH_CLAIMLIST_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
                dataloaded:false
            }
        default:
            return state
    }
}